import styled from "styled-components";

export const Card = styled.div`
  display: ${(props) => props?.display ?? "flex"};
  background-color: #fff;
  border: ${(props) => props?.border ?? "1px solid #f0f2f9"};
  min-height: ${(props) => props?.minHeight ?? "138px"};
  margin: ${(props) => props?.margin ?? "0px 16px 16px 16px"};
  padding: 18px 16px 0 16px;
  text-align: ${(props) => props?.textAlign ?? "inherit"};
  border-bottom: ${(props) => props?.borderBottom ?? "inherit"};
`;

export const PageTitle = styled.div`
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0.091px;
  margin-bottom: 16px;
  color: white;

  @media only screen and (min-width: 769px) {
    display: flex;
    font-size: 32px;
    margin-top: 24px;
    margin-bottom: 24px;
    margin-left: 16px;
  }
`;

export const Backdrop = styled.div`
  background: ${(props) => `url(${props?.background})`};
  height: auto;
  flex-direction: row;
  @media only screen and (min-width: 769px) {
    background-size: cover;
    background-repeat: no-repeat;
  }
`;

export const LabelCity = styled.h2`
  color: white;
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  text-shadow: -1.009px 0.673px 0px #f45320;
  font-family: "Helvetica LT Std Bold";
  font-size: 16.149px;
  font-style: italic;
  line-height: 12.784px; /* 79.167% */
  text-transform: uppercase;
  letter-spacing: -0.25px;

  @media only screen and (min-width: 769px) {
    text-shadow: -1.804px 1.203px 0px #f45320;
    font-family: "Helvetica LT Std Bold";
    font-size: 28.864px;
    line-height: 22.851px; /* 79.167% */
    text-transform: uppercase;
    text-align: center;
  }
`;

export const Container = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
  @media only screen and (min-width: 769px) {
    justify-content: center;
  }
`;

export const Headline = styled.h2`
  text-align: center;
  color: white;
  font-size: 12px;
  line-height: 24px;
  letter-spacing: 0.08px;
  margin: 0;

  @media only screen and (min-width: 769px) {
    font-size: 28px;
    line-height: 40px;
  }
`;

export const Box = styled.div`
  justify-content: center;
  display: flex;
  border-radius: 16px;
  background: linear-gradient(
    90deg,
    rgba(4, 195, 243, 0.56) 0%,
    rgba(28, 117, 188, 0.86) 49.95%,
    rgba(39, 43, 100, 0.81) 100%
  );
  text-align: center;
  white-space: pre;
  padding: 8px 10px;
  border: 2px solid #fff;
  max-width: 190px;
  @media only screen and (min-width: 769px) {
    padding: 20px;
    max-width: max-content;
    width: auto;
  }
`;

export const KVImg = styled.img`
  width: 153px;
  height: 232px;
  @media only screen and (min-width: 769px) {
    width: auto;
    height: auto;
  }
`;

export const TitleImg = styled.img`
  width: 197px;
  margin-bottom: 16px;
  @media only screen and (min-width: 769px) {
    width: 430px;
  }
`;

export const PinImg = styled.img`
  width: 16px;
  @media only screen and (min-width: 769px) {
    width: 28.864px;
  }
`;

export const ContainerKV = styled.div`
  width: 50%;
  margin-top: 64px;
  @media only screen and (min-width: 769px) {
    width: auto;
  }
`;

export const ContainerInfo = styled.div`
  width: 50%;
  margin-right: 16px;
  margin-top: 64px;
  @media only screen and (min-width: 769px) {
    width: auto;
    margin-left: 24px;
  }
`;

export const ContentWrapper = styled.div`
  margin-top: 50px;
  z-index: 2;
  width: 100%;
  min-height: 100px;
  height: auto;
  background-color: ${(props) => props?.bgColor ?? "inherit"};
  border-radius: 16px 16px 0 0;

  @media only screen and (min-width: 769px) {
    margin-top: 100px;
  }
`;

export const SubtitleS2 = styled.span`
  font-size: 24px;
  font-weight: 600;
  font-color: #1f2d3d;
  line-height: 34px;
  letter-spacing: 0.2px;
`;

export const Caption = styled.span`
  font-size: ${(props) => props?.fontSize ?? "14px"};
  letter-spacing: 0.08px;
  color: ${(props) => props?.color ?? "#1F2D3D"};
  white-space: ${(props) => props?.whiteSpace ?? "normal"};
`;

export const Label = styled.div`
  font-size: 13px;
  color: #6a7481;
  justify-content: flex-start;
  display: flex;
  font-weight: 600;
`;

export const ContainerRegistration = styled.div`
  @media only screen and (min-width: 769px) {
    gap: 24px;
  }
  display: flex;
  justify-content: center;
  align-items: end;

  margin: ${(props) => props?.margin ?? "0"};
  max-width: 374px;
`;

export const SelectionCityRegistration = styled.div`
  display: flex;
  cursor: pointer;
  padding: 8px 16px;
  flex-direction: row;
  justify-content: ${(props) => props?.justifyContent ?? "space-between"};
  align-items: center;
  align-self: stretch;
  border-radius: var(--Radius-small, 16px);
  border: 1px solid var(--Pallete-Color-Grey-50, #dde2e8);
  background: ${(props) => props?.background ?? "none"};
  margin-top: 8px;
  background-size: cover;
  min-height: 80px;
  @media only screen and (min-width: 769px) {
    min-width: 325px;
  }
`;
